export default __webpack_public_path__ + "static/media/womenShomiz.f2c2e0f8.svg";